import { FormControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, OnInit, ElementRef, ViewChild, NgZone, AfterViewInit, ViewContainerRef, TemplateRef, Input } from "@angular/core";
import { UploadEvent, FileRestrictions, SuccessEvent, RemoveEvent, CancelEvent } from "@progress/kendo-angular-upload";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { ISubscription } from "rxjs/Subscription";

import { CommonService } from "@shared/services/common";
import { AuthService } from "src/app/services/auth.service";
import { TabOpenService } from "src/app/services/tab-open.service";
import { FSliteTradeService } from "@fs/services/trades";
import { ServiceItemService } from "src/app/fs-lte/services/price-book/service-item/service-item.service";
import { DataSharingLTE } from "@fs/services/data-sharing-lte";

import { PriceModel, PriceBucketModel } from "src/app/fs-lte/models/price-book/price-book.model";
import { ServiceItemModel } from "src/app/fs-lte/models/price-book/service-item.model";
import { CommonMethods } from "src/app/services/common.method";

import { Constants } from "@shared/models/constants";
import { Tabs } from "src/app/enums/tab.enum";
import { NotificationsService } from "@shared/services/notification";
import { Attachment, ExternalAttachment } from "src/app/fs-lte/models/price-book/material-item.model";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { customJS } from "@fs/services/customjs";
import { ProductItemType } from "@fs/enums/common-enums";
import { of, Subject } from "rxjs";
import { catchError, debounceTime, switchMap, takeUntil } from "rxjs/operators";

declare var initBodyCustomScroll: any;
declare var SimpleBar: any;

@Component({
  selector: "app-service-item-form",
  templateUrl: "./service-create.component.html",
  styleUrls: ["./service-create.component.scss"],
  providers: [FSliteTradeService, ServiceItemService]
})
export class ServiceItemFormComponent implements OnInit, AfterViewInit {
  @ViewChild("laborItems") laborItemsDiv: ElementRef;
  @ViewChild("materialItems") materialItemsDiv: ElementRef;
  @ViewChild("serviceUploadImageBtn") serviceUploadImageBtn: ElementRef;
  @ViewChild("attachImagePreview") attachImagePreview: ElementRef;
  @ViewChild("attachmentDragAndDropImage") attachmentDragAndDropImage: ElementRef;
  @ViewChild("attachmentDeletePreview") attachmentDeletePreview: ElementRef;
  @ViewChild("attachmentUploadImageBtn") attachmentUploadImageBtn: ElementRef;
  @Input() tabCounter: number;
  @ViewChild("LIDropDown", {
    read: ViewContainerRef
  }) kendoMultiSelectNoDataTemplate: ViewContainerRef;

  private k_grid: any;
  private dataLoaderCount = 2;
  private destroyTab: boolean = false;
  private subscriptions: ISubscription[] = [];
  private kendoUploadFileList: {
    Description: string;
    Urls: string[];
    FileName: string[];
    Uids: string[];
  } = { Description: "", Urls: [], FileName: [], Uids: [] };

  public defaultLaborImage: string = Constants.DefaultImagePaths.Labour;
  public defaultMaterialImage: string = Constants.DefaultImagePaths.Material;
  public serviceDetailData: ServiceItemModel;
  public serviceItemForm: FormGroup;
  public initialData: any;
  public searchStringMaterial: string = "";
  public categories: any = [];
  public materialItems: any = [];
  public inputParams: any;
  public laborItems: any = [];
  public liLaborDropDownValues: any = [];
  public liMaterialDropDownValues: any = [];
  public searchString: any = "";
  public itemImageSrc = Constants.DefaultImagePaths.Service;
  public laborItemsValid: boolean = true;
  public materialItemsValid: boolean = true;
  public selectedMaterialItems: any = [];
  public selectedLaborItems: any = [];
  public formType = "New";
  public isAttachmentTypeImage: boolean = true;
  public modalOptions: { showAttachment: boolean } = { showAttachment: false };
  
  public attachments: GridDataResult = { data: [], total: 0 };
  public totalMaterialCost = 0;
  public totalMaterialPrice = 0.0;
  public totalLaborCost = 0;
  public totalLaborPrice = 0;
  public saveUrl: string = "";
  public isUnsavedTriggered: boolean = false;
  public deleteMessage: string = "";
  public deleteDataItem: any;
  public showDeleteConfirmation: boolean = false;
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: Constants.DefaultFileExtension,
    maxFileSize: Constants.DefaultFileSize.inbytes
  };
  public cancelConfirmation = false;
  public formatOptions: any = {
    style: "currency",
    currency: ""
  };

  /** update flag when file upload is in progress */
  public isUploadInProgress = false;
  public isEditAttachment: boolean = false;
  public editAttachmentForm: FormGroup;
  /** used for attachment slider */
  public showAttachmentSlider: boolean = false;
  /** used for attachment slider */
  public slideIndex: number = 0;
  public qbVersion: string = "";
  public allowedextensionsforAttachment :string = '';
  public allowedsizeforAttachment: number = 0;
  public state: DataSourceRequestState = {
    skip: 0,
    take: -1,
    sort: [],
  };
  public showNoRecord: boolean = false;
  public chkIsFreqUsed: string;
  public chkAllowPriceEd: string;
  public chkAllowDescEd: string;
  public chkIsTaxable: string;
  productItemType = ProductItemType;
  laborSearchTerm$ = new Subject<string>();
  materialSearchTerm$ = new Subject<string>();
  protected readonly ngUnsubscribe$ = new Subject();
  overlay: boolean = false;

  constructor(
    private frmbuilder: FormBuilder,
    private dataSharing: DataSharingLTE,
    private tabOpen: TabOpenService,
    private commonMethods: CommonMethods,
    private toastr: NotificationsService,
    private $elementRef: ElementRef,
    private zone: NgZone,
    private httpServiceItem: ServiceItemService,
    private httpCommon: CommonService,
    private auth: AuthService,
    private fSliteTradeService: FSliteTradeService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef
  ) {
    this.registerSearch();
  }

  //#region Life-cycle Events
  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.destroySubscriptions();
  }

  ngOnInit() {
    this.httpCommon
      .GetIntialData(
        this.auth.getCompanyId(),
        "ServiceTypes,PriceBookAccountingCodes,PriceBuckets"
      ).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(response => {
        this.initialData = response;
      });
    this.CreateServiceItemForm();
    this.saveUrl = this.httpServiceItem.UploadDocument();
    let subscription = this.tabOpen.routeToParentEvent.subscribe(response => {
      if (
        response.tabCounter == this.tabCounter &&
        response.event.split("|")[0] == "replaceTab" &&
        response.event.split("|")[1] == "discard"
      ) {
        $(this.$elementRef.nativeElement)
          .find(".tabs__content__box")
          .removeClass("dirty");
        this.CheckAndReplace();
        this.destroySubscriptions();
      } else if (
        response.tabCounter == this.tabCounter &&
        response.event.split("|")[0] == "replaceTab" &&
        response.event.split("|")[1] == "save"
      ) {
        this.CreateServiceItem();
      }
    });
    this.subscriptions.push(subscription);
    subscription = this.tabOpen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        this.CreateServiceItem();
      }
    });
    this.subscriptions.push(subscription);

    subscription = this.tabOpen.ChangeComponentEvent.subscribe(response => {
      if (response.removeSubscriptions != undefined) {
        if (response.removeSubscriptions) {
          this.destroySubscriptions();
        }
      }
    })
    this.subscriptions.push(subscription);
    this.GetTrades();
    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();

    this.allowedextensionsforAttachment = this.commonMethods.FileExtensionArrayToCommaSeparatedString(this.uploadRestrictions.allowedExtensions);
    this.allowedsizeforAttachment = Constants.DefaultFileSize.inMegabytes;

    //#region Generate random Ids for controls
    this.chkIsFreqUsed = "ChkFreqUsed_" + CommonMethods.GenerateRandomID();
    this.chkAllowPriceEd = "ChkAllPriceEd_" + CommonMethods.GenerateRandomID();
    this.chkAllowDescEd = "ChkAllDescEd_" + CommonMethods.GenerateRandomID();
    this.chkIsTaxable = "ChkIsTaxable" + CommonMethods.GenerateRandomID();
    //#endregion
    if (this.inputParams != undefined && this.inputParams.ID != undefined) {
      this.formType = "Edit";
      this.GetServiceItem();
      this.HideDataLoader();
    } else {
      this.HideDataLoader();
      this.CreateServiceItemForm();
    };
  }

  ngAfterViewInit() {
    this.commonMethods.ApplyMaxLengthForKendoNumericBox(16);
  }

  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.serviceItemForm.dirty;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabOpen.unsavedChangedDetected({
          dirty: isDirty,
          Index: this.tabCounter
        });
      }
    }
  }

  //#endregion

  //#region Private Methods
  private GetMaterialItems(searchKey) {
    this.httpServiceItem.GetMaterialItems(this.state, searchKey)
    .pipe(takeUntil(this.ngUnsubscribe$))
    .subscribe(response => {
      this.materialItems = response.MaterialItems;
      this.liMaterialDropDownValues = this.GetSIDropdownValues();
    });
  }

  private GetLaborItems(searchKey) {
    this.httpServiceItem.GetLaborItems(this.state, searchKey)
    .pipe(takeUntil(this.ngUnsubscribe$))
    .subscribe(response => {
      this.laborItems = response.LaborItems;
      this.liLaborDropDownValues = this.GetLIDropdownValues();
    });
  }

  private destroySubscriptions() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }

  private GetSIDropdownValues() {
    return this.materialItems.filter(
      x => this.selectedMaterialItems.find(y => y.ID == x.ID) == null
    );
  }

  private GetLIDropdownValues() {
    return this.laborItems.filter(
      x => this.selectedLaborItems.find(y => y.ID == x.ID) == null
    );
  }

  private GetSelectedMaterialItems() {
    return {
      data: this.selectedMaterialItems,
      total: this.selectedMaterialItems.length
    };
  }

  private GetSelectedLaborItems() {
    return {
      data: this.selectedLaborItems,
      total: this.selectedLaborItems.length
    };
  }

  private ReCalculateLaborTotal() {
    this.totalLaborCost = 0;
    this.totalLaborPrice = 0;
    this.selectedLaborItems.forEach(element => {
      this.totalLaborCost = this.totalLaborCost + element.Cost * element.Hours;
      this.totalLaborPrice =
        this.totalLaborPrice +
        (element.Prices[0] ? element.Prices[0].Amount : 0) * element.Hours;
    });
  }

  private ReCalculateMaterialTotal() {
    this.totalMaterialCost = 0;
    this.totalMaterialPrice = 0.0;
    this.selectedMaterialItems.forEach(element => {
      this.totalMaterialCost =
        this.totalMaterialCost +
        element.Item.StandardCost * element.Quantity;
      this.totalMaterialPrice =
        this.totalMaterialPrice +
        (element.Prices[0] ? element.Prices[0].Amount : 0) * element.Quantity;
    });
  }

  private GetTrades() {
    this.overlay = true;
    this.fSliteTradeService.fetch("", {}, "").subscribe(
      r => {
        this.categories = r.Children;
        setTimeout(() => {
          this.serviceItemForm.controls["Category"].setValue(
            CommonMethods.CheckNullOrUndefined(
              this.serviceDetailData.Category
            )
              ? ""
              : this.serviceDetailData.Category.ID
          );
          this.overlay = false;
        }, 1000);
      },
      error => {
        this.overlay = false;
        this.HideDataLoader();
      }
    );
  }

  private GetServiceItem() {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.httpServiceItem.GetServiceItem(this.inputParams.ID)
    .pipe(takeUntil(this.ngUnsubscribe$))
    .subscribe(
      response => {
        this.HideDataLoader();
        this.serviceDetailData = response;
            if (!CommonMethods.CheckNullOrUndefined(response)) {
                if (!CommonMethods.CheckNullOrUndefined(response.PriceBookItem)) {
                    this.serviceDetailData.IsFrequentlyUsed = response.PriceBookItem.IsFrequentlyUsed;
                    this.serviceDetailData.IsPriceEditAllowed = response.PriceBookItem.IsPriceEditAllowed;
                    this.serviceDetailData.IsDescriptionEditAllowed = response.PriceBookItem.IsDescriptionEditAllowed;
                    this.serviceDetailData.IsTaxable = response.PriceBookItem.IsTaxable;
                    this.serviceDetailData.IsAgreementExcluded = response.PriceBookItem.IsAgreementExcluded;
                }
        }
        this.CreateServiceItemForm();
        this.attachments = {
          data: response.Attachments,
          total: response.Attachments.length
        };
        this.attachments.data.forEach(x => {
          x.IsImage = !this.commonMethods.CheckLinkIsNotImage(x);
          x.UploadedBy = x.CreatedByUser;
        });
        let materialItems = [];
        let laborItems = [];
        response.MaterialItems.forEach(element => {
          element.MaterialItem.Prices = element.MaterialItem.PriceBookItem.Prices;
          element.MaterialItem.Quantity = element.Quantity;
          element.MaterialItem.IsOptional = element.IsOptional;
          materialItems.push(element.MaterialItem);
        });
        this.selectedMaterialItems = materialItems;
        response.LaborItems.forEach(element => {
          element.LaborItem.Prices = element.LaborItem.PriceBookItem.Prices;
          element.LaborItem.Hours = element.Hours;
          laborItems.push(element.LaborItem);
        });
        this.selectedLaborItems = laborItems;
        this.itemImageSrc =
          this.attachments.data.find(x => x.IsDefaultImage) != undefined
            ? this.attachments.data.find(x => x.IsDefaultImage).FilePath
            : this.itemImageSrc;
        this.ReCalculateMaterialTotal();
        this.ReCalculateLaborTotal();
      },
      error => {
        this.HideDataLoader();
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
  }

  private CreateServiceItemForm() {
    if (
      this.serviceDetailData == undefined ||
      this.serviceDetailData.ID == undefined
    ) {
      this.serviceDetailData = new ServiceItemModel();
    }
    this.serviceItemForm = this.frmbuilder.group({
      ID: new FormControl(this.serviceDetailData.ID),
      ItemNumber: new FormControl(
        this.serviceDetailData.ItemNumber,
        this.commonMethods.noWhitespaceValidator
      ),
      Description: new FormControl(
        this.serviceDetailData.Description,
        this.commonMethods.noWhitespaceValidator
      ),
      IsFrequentlyUsed: new FormControl(
        this.serviceDetailData.IsFrequentlyUsed
      ),
      Category: new FormControl(
        this.serviceDetailData.Category == null
          ? ""
          : this.serviceDetailData.Category.ID,
        Validators.required
      ),
      AccountingCode: new FormControl(
        this.serviceDetailData.AccountingCode == null
          ? ""
          : this.serviceDetailData.AccountingCode.ID
      ),
      Note: new FormControl(this.serviceDetailData.Note),
      StandardCost: new FormControl(
        this.serviceDetailData.Prices.length == 0
          ? 0
          : this.serviceDetailData.Prices[0].Amount,
        Validators.required
      ),
      Price: new FormControl(""),
      IsPriceEditAllowed: new FormControl(
        this.serviceDetailData.IsPriceEditAllowed
      ),
      IsDescriptionEditAllowed: new FormControl(
        this.serviceDetailData.IsDescriptionEditAllowed
      ),
      IsDiscountExcluded: new FormControl(
        this.serviceDetailData.IsDiscountExcluded
      ),
      IsAgreementExcluded: new FormControl(
        this.serviceDetailData.IsAgreementExcluded
      ),
      IsTaxable: new FormControl(this.serviceDetailData.IsTaxable),
      MaterialItems: new FormControl(),
      LaborItems: new FormControl(),
      Attachments: new FormControl()
    });
  }

  private ValidateInputExt(input, exts) {
    var fileName = input.value.toLowerCase();
    return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
      fileName
    );
  }

  private ReadURL(
    input,
    formType,
    DragAndDropImage,
    UploadImageBtn,
    ImagePreview,
    DeletePreview
  ) {
    let exts = this.uploadRestrictions.allowedExtensions;
    if (input.files && input.files[0]) {
      if (!this.ValidateInputExt(input, exts)) {
        this.toastr.error(
          "Sorry, uploaded file is invalid, allowed extensions are: " +
          exts.join(", "),
          "Error"
        );
        $(input).val("");
        return;
      }
      if (input.files[0].size > 4194304) // 4 m.b.
      {
        this.toastr.error("Sorry, File size is too large. Maximum file size permitted is 4 MB", "Error");
        $(input).val("");
        return;
      }
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      let postData = new FormData();
      postData.append("files", input.files[0]);
      this.isUploadInProgress = true;
      this.httpServiceItem.EditUploadDocument(postData)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        response => {
          this.editAttachmentForm.controls["ImagePath"].patchValue(
            response[0].StorageLocation
          );
          this.editAttachmentForm.controls["FileName"].patchValue(
            response[0].FileName
          );
          $(this.attachImagePreview.nativeElement).show();
          $(this.attachmentDragAndDropImage.nativeElement).hide();
          this.isUploadInProgress = false;
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        },
        error => {
          this.isUploadInProgress = false;
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          if (!CommonMethods.CheckNullOrUndefined(error.error))
            this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
    }
  }

  private IntializeEditAttachment(item = null) {
    let externalAttachment = !CommonMethods.CheckNullOrUndefined(item.ServiceItemExternalAttachment) ?
            item.ServiceItemExternalAttachment : item.ExternalAttachment;
    if (CommonMethods.CheckNullOrUndefined(externalAttachment))
      this.isAttachmentTypeImage = item.FileName == "" ? false : true;
    else
      this.isAttachmentTypeImage =
       externalAttachment == "" ? true : false;

    this.editAttachmentForm = this.frmbuilder.group({
      ID: new FormControl(item.ID),
      Uid: new FormControl(item.Uid),
      FileName: new FormControl(item.FileName),
      Description: new FormControl(
        item.FilePath == null ? "" : item.Description,
        Validators.maxLength(50)
      ),
      ImagePath: new FormControl(item.FilePath == null ? "" : item.FilePath),
      ExternalLink: new FormControl({value :
        CommonMethods.CheckNullOrUndefined(externalAttachment)
          ? ""
          : externalAttachment.ExternalUrl, disabled: true}
      ),
      IsDefaultImage: new FormControl(item.IsDefaultImage)
    });

    if (item.FilePath != "" && item.FilePath != null) {
      setTimeout(() => {
        $(this.attachImagePreview.nativeElement).show();
        $(this.attachmentDragAndDropImage.nativeElement).hide();
      }, 100);
    }
  }

  private RemoveDocument(dataItem) {
    if (dataItem.ID == null || dataItem.ID == "") {
      this.attachments.data.splice(
        this.attachments.data.findIndex(x => x.Uid == dataItem.Uid),
        1
      );
    } else {
      this.attachments.data.splice(
        this.attachments.data.findIndex(x => x.ID == dataItem.ID),
        1
      );
    }
  }

  private HideDataLoader() {
    this.dataLoaderCount = this.dataLoaderCount - 1;
    if (this.dataLoaderCount <= 0) {
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      this.dataLoaderCount = 0;
    }
  }

  private CheckAndReplace() {
    if (this.serviceDetailData.ID != "") {
      this.tabOpen.ReplaceTab(
        {
          CurrentTabIndex: this.tabCounter,
          newTabInfo: {
            tabId: Tabs.FsLiteServiceItemView,
            params: { ID: this.serviceDetailData.ID },
            tabTitle: "Service - " + this.serviceDetailData.ItemNumber
          }
        },
        true
      );
    } else {
      this.tabOpen.DestroyTab(this.tabCounter);
      let info = this.tabOpen.TabInfo;
      this.tabOpen.OpenTab({
        tabId: Tabs.FsLitePriceBookList,
        params: {},
        tabTitle: "Products"
      });
    }
  }
  //#endregion

  //#region Public Methods  
  registerSearch() {
    this.laborSearchTerm$.pipe(
      debounceTime(Constants.debounceInterval),
      switchMap((val:string) => this.httpServiceItem.GetLaborItems(this.state, val).pipe(
        catchError(() => {
          return of({ LaborItems: [], Count: 0 });
        })
    )),
    takeUntil(this.ngUnsubscribe$))
      .subscribe(r => {
        this.showspinner.hideLoader(this.kendoMultiSelectNoDataTemplate, this.tabCounter);
        let laborItems = r.LaborItems;
          if (laborItems != null) {
            if (this.selectedLaborItems.length > 0) {
              this.selectedLaborItems.forEach(element => {
                for (let i = 0; i < r.LaborItems.length; i++) {
                  if (r.LaborItems[i].ID == element.ID) {
                    laborItems.splice(i, 1);
                    break;
                  }
                }
              });
            }
          }
          this.liLaborDropDownValues = laborItems;
    });
    
    this.materialSearchTerm$.pipe(
      debounceTime(Constants.debounceInterval),
      switchMap((val:string) => this.httpServiceItem.GetMaterialItems(this.state, val).pipe(
        catchError(() => {
          return of({ MaterialItems: [], Count: 0 });
        })
    )),
    takeUntil(this.ngUnsubscribe$))
      .subscribe(r => {
        this.showspinner.hideLoader(this.kendoMultiSelectNoDataTemplate, this.tabCounter);
        let materialItems = r.MaterialItems;
        if (materialItems != null) {
          if (this.selectedMaterialItems.length > 0) {
            this.selectedMaterialItems.forEach(element => {
              for (let i = 0; i < r.MaterialItems.length; i++) {
                if (r.MaterialItems[i].ID == element.ID) {
                  materialItems.splice(i, 1);
                  break;
                }
              }
            });
          }
          this.liMaterialDropDownValues = materialItems;
          this.liMaterialDropDownValues.forEach(x => {
            if (!CommonMethods.CheckNullOrUndefined(x.Attachments, false)) 
              {
                let attachment = x.Attachments.find(y => y.IsDefaultImage);
                if (attachment != undefined) {
                  x.ImagePath = attachment.FilePath;
                }
                else
                  x.ImagePath = this.defaultMaterialImage;
              }
              else
                  x.ImagePath = this.defaultMaterialImage;
          });
        } else {
          this.liMaterialDropDownValues = [];
        }
    });
  }
  public SelectionChangeMaterial(value: any, ref: any): void {
    value.Quantity = 1;
    this.totalMaterialCost =
      this.totalMaterialCost + value.MaterialDetails.StandardCost;
    this.totalMaterialPrice =
      this.totalMaterialPrice +
      (value.Prices[0] != undefined && value.Prices[0] != null
        ? value.Prices[0].Amount
        : 0);
    value.MaterialDetails.ShortDescription = value.Description;
    value.Item = value.MaterialDetails;
    value.Item.Notes = value.Note;
    this.selectedMaterialItems.push(value);
    setTimeout(() => {
      ref.reset();
    }, 200);
  }

  public SelectionChangeLabor(value: any, ref: any): void {
    value.Hours = 0.0;
    value.Prices = value.PriceBookItem.Prices;
    this.selectedLaborItems.push(value);
    setTimeout(() => {
      ref.reset();
    }, 200);
  }

  public QuantityChanged(event, dataItem) {
    dataItem.Quantity = $(event.target).val();
    this.ReCalculateMaterialTotal();
  }

  public HoursChanged(value, dataItem) {
    dataItem.Hours = value;
    this.ReCalculateLaborTotal();
  }

  public LaborListBlur() {
    this.searchString = "";
    this.liLaborDropDownValues = [];
  }

  public MaterialListBlur() {
    this.searchStringMaterial = "";
    this.liMaterialDropDownValues = [];
  }

  public Labo1rDropdownFilterAPI(value) {
    if (value != undefined && value.trim() != "" && value.length > 2) {
      value = value.toLowerCase().trim();
      this.searchString = value;
      this.showspinner.showloader(this.kendoMultiSelectNoDataTemplate, this.tabCounter, Constants.defaultSpinnertimeout, true, this.liLaborDropDownValues.length);
      this.laborSearchTerm$.next(value);
    } else {
      this.searchString = "";
      this.showspinner.hideLoader(this.kendoMultiSelectNoDataTemplate, this.tabCounter);
      this.liLaborDropDownValues = [];
    }
  }

  public MaterialDropdownFilterAPI(value) {
    if (value != undefined && value.trim() != "" && value.length > 2) {
      this.showNoRecord = this.showspinner.showloader(this.kendoMultiSelectNoDataTemplate,this.tabCounter,Constants.defaultSpinnertimeout,true,this.liMaterialDropDownValues.length);
      value = value.toLowerCase().trim();
      this.searchStringMaterial = value;
      this.materialSearchTerm$.next(value);
    } else {
      this.searchStringMaterial = "";
      this.showNoRecord = this.showspinner.hideLoader(this.kendoMultiSelectNoDataTemplate,this.tabCounter);
      this.liMaterialDropDownValues = [];
    }
  }

  public MaterialDropdownFilter(value) {
    let items = this.GetSIDropdownValues();
    if (value != undefined && value != "") {
      value = value.toLowerCase();
      this.searchString = value;
      this.liMaterialDropDownValues = items.filter(s => {
        if (value != "") {
          if (
            s.ItemNumber.toLowerCase().indexOf(value) > -1 ||
            s.Description.toLowerCase().indexOf(value) > -1
          ) {
            return true;
          } else return false;
        }
      });
    } else {
      this.searchString = "";
      this.liMaterialDropDownValues = items;
    }
  }

  public MaterialItemNoteChanged(event, dataItem1) {
    dataItem1.Note = $(event.target).val();
  }

  public RemoveMaterialItem(item: any) {
    for (let i = 0; i < this.selectedMaterialItems.length; i++) {
      if (this.selectedMaterialItems[i].ID == item.ID) {
        this.selectedMaterialItems.splice(i, 1);
        break;
      }
    }
    this.ReCalculateMaterialTotal();
  }

  public RemoveLaborItem(item: any) {
    for (let i = 0; i < this.selectedLaborItems.length; i++) {
      if (this.selectedLaborItems[i].ID == item.ID) {
        this.selectedLaborItems.splice(i, 1);
        break;
      }
    }
    this.ReCalculateLaborTotal();
  }

  public CreateServiceItem() {
    if (
      this.serviceItemForm.valid &&
      $(this.$elementRef.nativeElement).find(".ng-invalid").length == 0
    ) {
      let submitModel: ServiceItemModel = new ServiceItemModel();
      submitModel.ID = this.serviceItemForm.value.ID;
      submitModel.ItemNumber = this.serviceItemForm.value.ItemNumber;
      submitModel.Description = this.serviceItemForm.value.Description;
      submitModel.IsFrequentlyUsed = this.serviceItemForm.value.IsFrequentlyUsed;
      submitModel.Category = { ID: this.serviceItemForm.value.Category };
      if (this.serviceDetailData.Prices.length > 0) {
        submitModel.Prices[0] = this.serviceDetailData.Prices[0];
        submitModel.Prices[0].ID = this.serviceDetailData.Prices[0].ID;
        submitModel.Prices[0].Amount = this.serviceItemForm.value.StandardCost;
        submitModel.Prices[0].IsDirty = true;
      } else if (this.initialData.PriceBuckets.length > 0) {
        let priceBuckets = this.initialData.PriceBuckets.filter(
          x => x.Name == "Standard"
        );
        let price = new PriceModel();
        let priceBucket = new PriceBucketModel();
        price.Amount = this.serviceItemForm.value.StandardCost;
        priceBucket.ID = priceBuckets != null ? priceBuckets[0].ID : "";
        price.Bucket = priceBucket;
        submitModel.Prices[0] = price;
      }
      if (this.serviceItemForm.value.AccountingCode != "")
        submitModel.AccountingCode = {
          ID: this.serviceItemForm.value.AccountingCode,
          Name: "",
          Description: ""
        };
      else submitModel.AccountingCode = null;

      submitModel.Note = this.serviceItemForm.value.Note;
      submitModel.IsDiscountExcluded = false; // as every item must has to be discountable
      //this.serviceItemForm.value.IsDiscountExcluded;
      submitModel.IsPriceEditAllowed = this.serviceItemForm.value.IsPriceEditAllowed;
      submitModel.IsDescriptionEditAllowed = this.serviceItemForm.value.IsDescriptionEditAllowed;
      submitModel.IsTaxable = this.serviceItemForm.value.IsTaxable;
      submitModel.IsAgreementExcluded = this.serviceItemForm.value.IsAgreementExcluded;
      this.selectedLaborItems.forEach(element => {
        submitModel.LaborItems.push({
          Hours: element.Hours,
          LaborItem: element
        });
      });
      this.selectedMaterialItems.forEach(element => {
        submitModel.MaterialItems.push({
          Quantity: element.Quantity,
          MaterialItem: element,
          IsOptional: true
        });
      });
      submitModel.Attachments = this.attachments.data;
      submitModel.ModifyDate = this.serviceDetailData.ModifyDate;
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      if (!CommonMethods.CheckNullOrUndefined(submitModel.ID, true)) {
        this.httpServiceItem.SaveEditItem(submitModel)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
          response => {
            if (
              $(this.$elementRef.nativeElement)
                .find(".tabs__content__box")
                .hasClass("dirty")
            ) {
              $(this.$elementRef.nativeElement)
                .find(".tabs__content__box")
                .removeClass("dirty");
            }
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);

            this.dataSharing.ItemChangeEvent();
            setTimeout(() => {
              if (this.destroyTab) {
                this.tabOpen.DestroyTab(this.tabCounter);
              } else {
                this.tabOpen.ReplaceTab({
                  CurrentTabIndex: this.tabCounter,
                  newTabInfo: {
                    tabId: Tabs.FsLiteServiceItemView,
                    params: { ID: submitModel.ID },
                    tabTitle: "Service - " + submitModel.ItemNumber
                  }
                });
              }
            }, 300);
            this.destroySubscriptions();
            this.toastr.success(
              "Service item " + submitModel.ItemNumber + " updated",
              "Success!"
            );
          },
          error => {
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            if (!CommonMethods.CheckNullOrUndefined(error.error))
              this.toastr.showMultiLineError(error.error.Message, "Error");
          }
        );
      } else {
        this.httpServiceItem.SaveServiceItem(submitModel)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
          response => {
            if (
              $(this.$elementRef.nativeElement)
                .find(".tabs__content__box")
                .hasClass("dirty")
            ) {
              $(this.$elementRef.nativeElement)
                .find(".tabs__content__box")
                .removeClass("dirty");
            }
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success(
              "Service item " + submitModel.ItemNumber + " created",
              "Success!"
            );
            this.dataSharing.ItemChangeEvent();
            //setTimeout(() => {
            if (this.destroyTab) {
              this.tabOpen.DestroyTab(this.tabCounter);
            } else {
              this.tabOpen.ReplaceTab({
                CurrentTabIndex: this.tabCounter,
                newTabInfo: {
                  tabId: Tabs.FsLiteServiceItemView,
                  params: { ID: response.ID },
                  tabTitle: "Service - " + submitModel.ItemNumber
                }
              });
            }
            // }, 300);
            this.destroySubscriptions();
          },
          error => {
            this.destroyTab = false;
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            if (!CommonMethods.CheckNullOrUndefined(error.error))
              this.toastr.showMultiLineError(error.error.Message, "Error");
          }
        );
      }
    } else {
      this.destroyTab = false;
      this.commonMethods.markFormGroupTouched(this.serviceItemForm);
      this.zone.runOutsideAngular(() => {
        customJS.verifyBoxes(this.$elementRef.nativeElement);
      });
    }
  }

  public OpenAttachment(e) {
    e.stopPropagation();
    this.isAttachmentTypeImage = true;
    this.modalOptions.showAttachment = true;
  }

  public ChangeAttachmentType(value) {
    this.isAttachmentTypeImage = value == "Image" ? true : false;
  }

  public UploadEventHandler(e: UploadEvent) {
    e.headers.set("Access-Control-Request-Headers", "authorization");
    e.headers.append("Authorization", "Bearer " + this.auth.getToken());
    this.isUploadInProgress = true;
  }

  public SuccessEventHandler(e: SuccessEvent) {
    if (e.operation == "upload") {
      if (e.response.body.length > 0) {
        if (this.kendoUploadFileList.FileName.length > 0 && this.kendoUploadFileList.FileName.find(x => x == e.files[0].name) != undefined) {
          e.preventDefault();
          this.toastr.error(
            "This file has already been attached, Please rename and try again."
          );
        }
        else {
          this.kendoUploadFileList.Urls.push(e.response.body[0].StorageLocation);
          this.kendoUploadFileList.FileName.push(e.files[0].name);
          this.kendoUploadFileList.Uids.push(e.files[0].uid);
        }

      }
      this.isUploadInProgress = false;
    }
  }

  public ErrorEventHandler(e: any) {
    if (e.response != null) {
      this.toastr.showMultiLineError(e.response.error.Message, "Error");
    } else {
      this.toastr.showMultiLineError("Something went wrong!", "Error");
    }
    this.isUploadInProgress = false;
  }

  public async AddDocuments(txtLinkUrl) {
    /* In case of external image */
    let hasExternalFileLink = txtLinkUrl.value != "";
    // attachment is not an uploaded image
    if (hasExternalFileLink) {
      let extFileGeneratedLink = await this.SaveExternalFileUrl(txtLinkUrl.value);
      //file uploaded to server and new azure link in generated for the file
      if (extFileGeneratedLink != null) {
        let attachment = new Attachment();
        attachment.IsDirty = false;
        attachment.IsDefaultImage = false;
        //description textbox is common for file upload or add external link
        attachment.Description = this.kendoUploadFileList.Description;
        if (extFileGeneratedLink.length > 0) {
          attachment.FilePath = extFileGeneratedLink[0]["StorageLocation"];
          attachment.FileName = extFileGeneratedLink[0]["FileName"];
          attachment.ExternalAttachment.AttachmentPath = extFileGeneratedLink[0]["StorageLocation"];
          attachment.ExternalAttachment.ExternalUrl = txtLinkUrl.value;
          attachment.ExternalAttachment.FileName = extFileGeneratedLink[0]["FileName"];
        } else {
          attachment.FileName = extFileGeneratedLink.FileName;
          attachment.FilePath = extFileGeneratedLink.AttachmentPath;
          attachment.ExternalAttachment.ID = extFileGeneratedLink.ID;
          attachment.ExternalAttachment.ExternalUrl = extFileGeneratedLink.ExternalUrl;
          attachment.ExternalAttachment.AttachmentPath = extFileGeneratedLink.AttachmentPath;
          attachment.ExternalAttachment.FileName = extFileGeneratedLink.FileName;
          attachment.ExternalAttachment.ModifyDate = extFileGeneratedLink.ModifyDate;
        }
        attachment.Uid = Math.floor(Math.random() * 100).toString();
        attachment.ExternalAttachment.IsDirty = false;
        attachment["IsImage"] = !this.commonMethods.CheckLinkIsNotImage(attachment);
        this.attachments.data.push(attachment);
        this.CloseModal();
      }
    } else {
      /* In case of file upload */
      for (let i = 0; i < this.kendoUploadFileList.Urls.length; i++) {
        let attachment = {
          IsDirty: false,
          IsDefaultImage: false,
          IsImage: false,
          Description: this.kendoUploadFileList.Description,
          FilePath: this.kendoUploadFileList.Urls[i],
          FileName: this.kendoUploadFileList.FileName[i],
          Uid: this.kendoUploadFileList.Uids[i],
          ExternalAttachment: null
        };
        attachment.IsImage = !this.commonMethods.CheckLinkIsNotImage(attachment);
        this.attachments.data.push(attachment);
        this.attachments.total = this.attachments.total + 1;
      }
      this.CloseModal();
    }
  }

  public SaveExternalFileUrl(url: string): Promise<any> {
    return new Promise(resolve => {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      this.httpServiceItem.UploadExternalDocument(JSON.stringify(url.trim()))
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(response => {
          this.HideDataLoader();
          resolve(response);
        },
          exception => {
            this.HideDataLoader();
            if (!CommonMethods.CheckNullOrUndefined(exception["error"]))
              this.toastr.showMultiLineError(exception["error"]["Message"], "Error");
            resolve(null);
          }
        );
    });
  }

  public DescriptionChanged(event) {
    this.kendoUploadFileList.Description = $(event.target).val().toString();
  }

  public async EditDocument() {
    let isValid = true;
    let currentID = this.editAttachmentForm.controls["ID"].value;
    let currentUid = this.editAttachmentForm.controls["Uid"].value;
    let filePath = this.editAttachmentForm.controls["ImagePath"].value;
    let fileName = this.editAttachmentForm.controls["FileName"].value;
    let externalFileURL = this.editAttachmentForm.controls["ExternalLink"].value;
    let externalAttachment = new ExternalAttachment();
    if (!this.isAttachmentTypeImage && externalFileURL != "") {
      let extFileGeneratedLink = await this.SaveExternalFileUrl(externalFileURL);
      let isDefaultImage = this.editAttachmentForm.controls["IsDefaultImage"].value;
      if (extFileGeneratedLink != null) {
        if (extFileGeneratedLink.length > 0) {
          filePath = extFileGeneratedLink[0]["StorageLocation"];
          fileName = extFileGeneratedLink[0]["FileName"];
          externalAttachment.AttachmentPath = extFileGeneratedLink[0]["StorageLocation"];
          externalAttachment.ExternalUrl = externalFileURL;
          externalAttachment.FileName = extFileGeneratedLink[0]["FileName"];
        } else {
          fileName = extFileGeneratedLink.FileName;
          filePath = extFileGeneratedLink.AttachmentPath;
          externalAttachment.ID = extFileGeneratedLink.ID;
          externalAttachment.ExternalUrl = extFileGeneratedLink.ExternalUrl;
          externalAttachment.AttachmentPath = extFileGeneratedLink.AttachmentPath;
          externalAttachment.FileName = extFileGeneratedLink.FileName;
          externalAttachment.ModifyDate = extFileGeneratedLink.ModifyDate;
        }
        if (isDefaultImage) {
          this.itemImageSrc = filePath;
        }
      } else {
        isValid = false;
      }
    } else {
      externalAttachment = null;
    }

    if (isValid) {
      if (
        this.attachments.data.find(x => currentID != null && currentID != "" && x.ID == currentID) != undefined
        || this.attachments.data.find(x => x.Uid == currentUid) != undefined
      ) {
        var attach = {
          ID: currentID,
          Description: this.editAttachmentForm.controls["Description"].value,
          FilePath: filePath,
          FileName: fileName,
          IsDefaultImage: this.editAttachmentForm.controls["IsDefaultImage"]
            .value,
          Uid: currentUid, // this.editAttachmentForm.controls["Uid"].value,
          ExternalAttachment: externalAttachment,
          IsImage: false,
          IsDirty: true
        };
        if (attach.FilePath.length <= 0) {
          this.RemoveDocument(attach);
        } else {
          var idx = this.attachments.data.findIndex(x => (currentID != null && currentID != "" && x.ID == currentID)
            || ((currentID == null || currentID == "") && x.Uid == currentUid));
          attach.IsImage = !this.commonMethods.CheckLinkIsNotImage(attach);
          this.attachments.data[idx] = attach;
        }
      }
      this.CloseEditModal();
    }
  }

  public RemovePreview(type, ImageFileControl1, ImageFileControl2, DragAndDropImage,
    UploadImageBtn, ImagePreview, DeletePreview) {
    $(ImageFileControl1).val("");
    $(ImageFileControl2).val("");
    this.editAttachmentForm.controls["ImagePath"].patchValue("");

    $(DeletePreview).hide();
    $(ImagePreview).hide();
    $(DragAndDropImage).show();
    $(UploadImageBtn).hide();
  }

  public ImageUploaded(selfRef, formType, DragAndDropImage, UploadImageBtn, ImagePreview, DeletePreview) {
    this.ReadURL(selfRef.target, formType, DragAndDropImage, UploadImageBtn, ImagePreview, DeletePreview);
  }

  public OpenEdit(dataItem) {
    this.IntializeEditAttachment(dataItem);
    this.isEditAttachment = true;
  }

  public CloseEditModal() {
    this.isEditAttachment = false;
  }

  
  public CancelEventHandler(e: CancelEvent) {
    this.isUploadInProgress = false;
  }

  public RemoveEventHandler(event: RemoveEvent) {
    let index = this.kendoUploadFileList.Uids.indexOf(event.files[0].uid);
    if (index != -1) // remove only if found
    {
      this.kendoUploadFileList.FileName.splice(index, 1);
      this.kendoUploadFileList.Urls.splice(index, 1);
      this.kendoUploadFileList.Uids.splice(index, 1);
    }
  }

  public ChangeIsDefault(event, dataItem) {
    let oldDefaultImage = this.attachments.data.find(x => x.IsDefaultImage);
    this.attachments.data.forEach(x => {
      if (x == dataItem) {
        x.IsDirty = !CommonMethods.CheckNullOrUndefined(x.ID);
        x.IsDefaultImage = $(event.target)[0].checked;
        if ($(event.target)[0].checked) {
          this.itemImageSrc = x.FilePath;
        } else {
          this.itemImageSrc = Constants.DefaultImagePaths.Service;
        }
      } else {
        if (x == oldDefaultImage) {
          x.IsDirty = !CommonMethods.CheckNullOrUndefined(oldDefaultImage.ID);
          x.IsDefaultImage = false;
        }
      }
    });
  }

  public CloseModal() {
    this.kendoUploadFileList.Description = "";
    this.kendoUploadFileList.Urls = [];
    this.kendoUploadFileList.FileName = [];
    this.kendoUploadFileList.Uids = [];
    this.isAttachmentTypeImage = true;
    this.modalOptions.showAttachment = false;
  }

  public OpenMaterialItem(data: any) {
    this.tabOpen.OpenTab({
      tabId: Tabs.FsLiteMaterialItemDetail,
      params: { ID: data.ID },
      tabTitle: "Material - " + data.ItemNumber
    });
  }

  public OpenLaborItem(data: any) {
    this.tabOpen.OpenTab({
      tabId: Tabs.FsLiteLaborItemDetail,
      params: { ID: data.ID },
      tabTitle: "Labor - " + data.ItemNumber
    });
  }

  public OnExpand() {
    $(document).on("click", ".k-hierarchy-cell>a", function () {
      $(this)
        .parents(".k-master-row")
        .addClass("active");
    });
  }

  public OnCollapse() {
    $(document).on("click", ".k-hierarchy-cell>a", function () {
      $(this)
        .parents(".k-master-row")
        .removeClass("active");
    });
  }

  public ReIntializeMaterialScroll() {
    this.zone.runOutsideAngular(() => {
      this.k_grid = new SimpleBar(
        $(this.$elementRef.nativeElement).find(
          ".service-item-material-grid .k-grid-aria-root"
        )[0],
        { autoHide: false }
      );
    });
  }

  public ReIntializeLaborScroll() {
    this.zone.runOutsideAngular(() => {
      this.k_grid = new SimpleBar(
        $(this.$elementRef.nativeElement).find(
          ".service-item-labor-grid .k-grid-aria-root"
        )[0],
        { autoHide: false }
      );
    });
  }

  public Delete(dataItem) {
    this.deleteDataItem = dataItem;
    this.showDeleteConfirmation = true;
    if (this.attachments.data.findIndex(x => x.ID == dataItem.ID) > -1) {
      this.deleteMessage = "This action will permanently delete the record.";
    }
  }

  public ConfirmDelete(ref) {
    this.showDeleteConfirmation = false;
    if (ref) {
      let dataItem = this.deleteDataItem;
      this.RemoveDocument(dataItem);
      this.toastr.success("Record deleted", "Success!");
    } else {
      this.deleteDataItem = null;
    }
  }

  public CancelAction() {

    if (this.serviceDetailData.ID != "") {
      this.tabOpen.ReplaceTab({
        CurrentTabIndex: this.tabCounter,
        newTabInfo: {
          tabId: Tabs.FsLiteServiceItemView,
          params: { ID: this.serviceDetailData.ID },
          tabTitle: "Service - " + this.serviceDetailData.ItemNumber
        }
      });
    } else {
      this.tabOpen.DestroyTab(this.tabCounter);
    }
  }

  /** used for attachment slider */
  ViewAttachmentSlide(idx: number) {
    this.slideIndex = idx;
    this.showAttachmentSlider = true;
  }
  /** used for attachment slider */
  CloseAttachmentSlider() {
    this.showAttachmentSlider = false;
  }
  //#endregion
}